import { useApplicationContext } from '@/context/v1/Application/context';
import { useKimLhc } from '@/context/KimLhc';
import { useStepMutation } from '@/components/views/Report/KimLhc/hooks/useStepMutation';
import { FormFields } from '@/components/views/Report/KimLhc/types';

interface ResultParams {
	id: string;
	file_id: string;
	company_id: string;
	organization_id: string;
	comment?: string;
}

export const useResult = () => {
	const { file_id, report_id, form } = useKimLhc();
	const { organization, company } = useApplicationContext();
	const { mutate, isLoading } = useStepMutation<ResultParams>();

	const handleSubmit = async (values: FormFields): Promise<void> => {
		const hasChanges = form.isFieldsTouched(['result'], true);

		if (!report_id || !hasChanges || !file_id || !company?.id || !organization?.id) {
			return;
		}

		await mutate({
			id: report_id,
			file_id,
			company_id: company.id,
			organization_id: organization.id,
			comment: values.result?.comment ?? undefined
		});
	};

	return { handleSubmit, isLoading };
};
